export const inp = "w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2.5 rounded text-sm text-white";
export const lbl = "text-[10px] tracking-widest uppercase text-neutral-400 block mb-1";
export const btnGold = "btn-gold px-5 py-2.5 rounded text-xs tracking-widest uppercase font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50";
export const btnGhost = "px-4 py-2.5 rounded text-xs tracking-widest uppercase border border-white/15 text-neutral-200 hover:border-[#D4AF37] hover:text-[#D4AF37] inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-50";

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");

export const STATUS_STYLE = {
  scheduled: "border-sky-400/40 text-sky-300",
  open: "border-emerald-400/50 text-emerald-300",
  closed: "border-neutral-500/50 text-neutral-400",
};

export async function downloadFile(api, url, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
